import { httpGet } from '../services/http'
import authProvider from '../utils/authProvider'

const runnerApi = process.env.REACT_APP_RUNNERS_API

const RunnerProvider = {
  getList: async (resource, { pagination, filter }) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const url = `${runnerApi}?f=${JSON.stringify(filter)}&p=${JSON.stringify({ perPage: 40, ...pagination })}`
    const { data: response } = await httpGet({ url, config: { headers } })
    return Promise.resolve({ data: response.items, total: response.count })
  },

  getMany: async () => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const url = `${runnerApi}?f={}&p={"page":1,"perPage":100}`
    const { data: response } = await httpGet({ url, config: { headers } })
    return Promise.resolve({ data: response.items, total: response.count })
  },

  getOne: async (resource, params) => {
    const token = await authProvider.getToken()
    const headers = { Authorization: `Bearer ${token}` }
    const { data: response } = await httpGet({ url: `${runnerApi}/${params.id}`, config: { headers } })
    return Promise.resolve({ data: response })
  },
}

export default RunnerProvider
